import { LoanProductCategory } from '@ilg-totallymoney/types'
import Image from 'next/image'

import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Heading from '@ilg-totallymoney/ui/components/Heading'

const ProviderLogoImage = (imageProps: {
    alt: string
    height: number
    src: string
    width: number
}) => (
    <Box width={[75, 120, 150]}>
        <Image {...imageProps} style={{ maxWidth: '100%', height: 'auto' }} />
    </Box>
)

const ProviderLogos = ({ category }: { category: LoanProductCategory }) => {
    if (category === 'Secured') {
        return null
    }

    return (
        <Flex flexDirection="column" alignItems="center" pb="space50">
            <Box mb="space30">
                <Heading variant="60">
                    We compare hundreds of loans from leading lenders
                </Heading>
            </Box>

            <Flex
                flexWrap="wrap"
                alignItems="center"
                justifyContent="center"
                gridGap="space30"
            >
                <ProviderLogoImage
                    src="https://s3-eu-west-1.amazonaws.com/loans-api/production/images/AA.jpg"
                    alt="AA logo"
                    width={150}
                    height={75}
                />
                <ProviderLogoImage
                    src="https://s3-eu-west-1.amazonaws.com/loans-api/production/images/postoffice.png"
                    alt="Post Office logo"
                    width={150}
                    height={75}
                />
                <ProviderLogoImage
                    src="https://s3-eu-west-1.amazonaws.com/loans-api/production/images/HSBC.png"
                    alt="HSBC logo"
                    width={154}
                    height={64}
                />
                <ProviderLogoImage
                    src="https://s3-eu-west-1.amazonaws.com/loans-api/production/images/natwest.png"
                    alt="Natwest logo"
                    width={150}
                    height={75}
                />
                <ProviderLogoImage
                    src="https://s3-eu-west-1.amazonaws.com/loans-api/production/images/tesco.png"
                    alt="Tesco logo"
                    width={150}
                    height={75}
                />
                <ProviderLogoImage
                    src="https://s3-eu-west-1.amazonaws.com/loans-api/production/images/RBS.png"
                    alt="RBS logo"
                    width={150}
                    height={75}
                />
                <ProviderLogoImage
                    src="https://s3-eu-west-1.amazonaws.com/loans-api/production/images/ratesetter.png"
                    alt="RateSetter logo"
                    width={150}
                    height={75}
                />
            </Flex>
        </Flex>
    )
}

export default ProviderLogos
